import { Box, InputAdornment } from '@mui/material'
import Input from '../../../../../components/Input'
import TestIds from '../../../../../testIds'

export interface FreightChargeInputProps {
  freightCharge: string
  setFreightCharge: React.Dispatch<React.SetStateAction<string>>
  setFreightChargePrice: React.Dispatch<React.SetStateAction<number>>
}

export function FreightChargeInput({
  freightCharge,
  setFreightCharge,
  setFreightChargePrice,
}: FreightChargeInputProps) {
  return (
    <Box minWidth={272} width='40%' key='FreightChargeBox'>
      <Input
        label='Freight Charge'
        key='FreightChargeInput'
        testId={TestIds.feat.quotes.sendOffer.freight}
        placeholder={'0.00'}
        value={freightCharge}
        setValue={(v) => {
          const value = v?.valueOf().toString()
          if (!value) {
            setFreightCharge('')
            setFreightChargePrice(0)
            return
          }
          const regex = /^\d{0,9999}(\.\d{0,2})?$/
          if (regex.test(value) || value === '') {
            setFreightCharge(value)
            setFreightChargePrice(parseFloat(value))
          }
        }}
        disableError
        outlineInputProps={{
          type: 'number',
          startAdornment: <InputAdornment position='start'>$</InputAdornment>,
        }}
        type='number'
      />
    </Box>
  )
}
